module.exports = __webpack_public_path__ + "static/paul-ef7545516f1a0af54d060656a3f7a552.png";